<template>
  <container fluid>
    <v-row align="center" class="d-flex justify-center download-section">
      <v-col cols="12" md="6" class="d-flex justify-center">
        <div class="left-widget">
          <v-img src="../assets/computers.png" class="d-none d-sm-none" max-width="500" max-height="350"
            alt="Image"></v-img>
          <h1>Policorp Linux</h1>
          <h3>Com uma base sólida e eficiente, Policorp Linux oferece um desempenho veloz e estável para todas as suas
            tarefas diárias.</h3>
          <v-row justify="center pt-12">
            <v-btn @click="scrollToForm" color="secondary mr-2">Baixe Agora</v-btn>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6">
        <div class="right-widget d-none d-md-flex">
          <v-img src="../assets/computers.png" max-width="500" max-height="350" alt="Image"></v-img>
        </div>
      </v-col>
    </v-row>

    <v-row
      v-if="showForm"
      ref="formSection"
      align="center"
      class="info-section justify-center mb-12"
    >
      <v-col cols="12" md="8" lg="6">
        <v-row class="mb-4">
          <v-col>
            <h2 class="text-center" style="color: #1976D2; font-weight: bold;">
              🎉 Obrigado por instalar o <span style="color:#1976D2;">Policorp Linux</span>! 🎉<br>
              Aproveite ao máximo o seu sistema e fique por dentro das novidades.
            </h2>
          </v-col>
        </v-row>

        <v-form v-if="!submited" v-model="form" @submit.prevent="submitForm" ref="form">
          <v-row>
            <v-col cols="12">
              <div class="aviso-legal mb-2" style="color: #1976D2; text-align: left; font-size: 14px;">
                <h3 class="mb-2" style="color: #2034ebff; font-weight: bold;">
                  <v-icon color="orange" left>mdi-alert</v-icon>
                  Aviso Legal – Licenciamento e Distribuição do Policorp Linux
                </h3>

                <p class="mb-3">
                  O <strong style="color: #2034ebff;">Policorp Linux</strong> é disponibilizado gratuitamente
                  exclusivamente para
                  <strong style="color: #2034ebff;">uso pessoal, em empresas públicas e privadas</strong>, nos termos
                  das condições aqui estabelecidas.
                </p>

                <p class="mb-2">
                  Fica expressamente <strong style="color: #2034ebff;">vedada a comercialização, redistribuição,
                    sublicenciamento, revenda ou qualquer forma de exploração comercial</strong>
                  do Policorp Linux, total ou parcial, sem a devida autorização formal e contrato comercial firmado
                  entre as partes interessadas e a detentora dos direitos sobre o sistema.
                </p>

                <p class="mb-2">
                  A utilização do Policorp Linux por <strong style="color: #2034ebff;">empresas, fabricantes,
                    integradores, distribuidores ou quaisquer entidades com fins lucrativos</strong>
                  somente será permitida mediante a formalização prévia de contrato comercial específico, que
                  regulamente os direitos, deveres e condições de uso.
                </p>

                <p class="mb-2">
                  O <strong style="color: #2034ebff;">descumprimento destas disposições</strong> poderá implicar em
                  medidas legais cabíveis, nos termos da legislação vigente sobre propriedade intelectual e direitos
                  autorais.
                </p>

                <p class="mb-0">
                  Para <strong style="color: #2034ebff;">parcerias comerciais ou licenciamento corporativo</strong>,
                  <a href="https://www.policorp.com.br/contato" target="_blank" class="alert-link">entre em contato</a>
                  com o departamento responsável ou através dos canais oficiais da Policorp Tecnologia.
                </p>
              </div>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="formData.nome" label="Nome" :rules="[required]" required></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="formData.email" :readonly="loading" :rules="[required, emailValidationRule]"
                class="mb-2" label="Email" clearable required></v-text-field>
            </v-col>

          </v-row>
          <v-row class="d-flex justify-center overflow-auto recommended">
            <v-col cols="12">
              <v-card class="elevation-10 mb-6">
                <v-card-title class="headline text-center">MD5 da ISO policorp-13.1-amd64.iso</v-card-title>
                <v-list-item-subtitle>d0620cb9695e95ca9290e3b1012e07e9</v-list-item-subtitle>
                <v-divider></v-divider>

                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="d-flex justify-center overflow-auto recommended">
            <v-col cols="12" md="6">
              <v-card class="elevation-10 mb-6">
                <v-card-title class="headline text-center">Requisitos Mínimos</v-card-title>
                <v-divider></v-divider>

                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Processador</v-list-item-title>
                      <v-list-item-subtitle>1 GHz Dual Core - Intel/AMD64-bit</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>RAM</v-list-item-title>
                      <v-list-item-subtitle>4 GB RAM</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Armazenamento</v-list-item-title>
                      <v-list-item-subtitle>20 GB</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card class="elevation-10 mb-6">
                <v-card-title class="headline text-center">Requisitos Recomendados</v-card-title>
                <v-divider></v-divider>

                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Processador</v-list-item-title>
                      <v-list-item-subtitle>2 GHz processador dual-core </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>RAM</v-list-item-title>
                      <v-list-item-subtitle>8 GB RAM</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Armazenamento</v-list-item-title>
                      <v-list-item-subtitle>SSD com 32 GB de disco</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="mb-3">
              <v-alert
                dense
                outlined
                type="warning"
                border="left"
                color="#0000000"
                icon="mdi-laptop"
                class="install-warning"
              >
                <strong>Compatibilidade:</strong> apenas sistemas 64-bit (x86_64), sem suporte para i386.<br>
                <strong>Importante:</strong> Habilite o modo UEFI na BIOS antes da instalação.
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col align="center" cols="12" class="mb-12">
              <v-btn type="submit" color="primary">Enviar</v-btn>
            </v-col>
          </v-row>
        </v-form>
        <div v-else>
          <h1>O download não iniciou? Tente novamente clicando <a :href="downloadLink" download>aqui</a></h1>
        </div>
      </v-col>
    </v-row>
    <v-row align="center" class="info-section justify-center mb-12">
      <v-col cols="12">
        <div class="info-title text-center">
          <h2 class="mb-6 text-lg">
            🚀 Estamos felizes em anunciar o lançamento do <strong>Policorp Linux 13.1</strong>
          </h2>
        </div>
        <h4 class="info-section-black text-center mb-12">
          Uma nova versão Linux desenvolvida para oferecer um sistema mais rápido, simples e fácil de usar.
        </h4>
      </v-col>
    </v-row>


    <v-row align="center" class="info-section justify-center mb-12">
      <v-col cols="12">
        <div class="info-title">
          <h2 class="mb-3">✨ O que torna o Policorp Linux especial?</h2>
        </div>
        <h4 class="info-section-black pb-8">
          <v-icon color="success">mdi-star-circle</v-icon> Fácil de usar: instalação rápida, interface amigável e
          configuração automática de drivers.<br>
          <v-icon color="success">mdi-star-circle</v-icon> Leve e rápido: otimizado para rodar em computadores novos e
          antigos, consumindo poucos recursos.<br>
          <v-icon color="success">mdi-star-circle</v-icon> Seguro e confiável: atualizações frequentes, firewall
          integrado e foco em estabilidade.<br>
          <v-icon color="success">mdi-star-circle</v-icon> Pronto para uso: vem com aplicativos essenciais
          pré-instalados (navegador, editor de texto, pacote office, multimídia e muito mais).<br>
          <v-icon color="success">mdi-star-circle</v-icon> Personalizável: escolha entre diferentes wallpapers,
          conjuntos de ícones, cores e personalize o ambiente gráfico GNOME ao seu estilo.<br>
          <v-icon color="success">mdi-star-circle</v-icon> Baseado e compatível com o Debian Linux e derivados.<br>
        </h4>
      </v-col>

      <v-col cols="12">
        <div class="info-title">
          <h2 class="mb-3">🎯 Para quem é o Policorp Linux?</h2>
        </div>
        <h4 class="info-section-black pb-8">
          <v-icon color="success">mdi-target</v-icon> Usuários domésticos que querem substituir o Windows sem
          complicação.<br>
          <v-icon color="success">mdi-target</v-icon> Profissionais que buscam um sistema estável para trabalho e
          estudo.<br>
          <v-icon color="success">mdi-target</v-icon> Empresas que desejam reduzir custos com licenças e aumentar a
          segurança.<br>
          <v-icon color="success">mdi-target</v-icon> Fabricantes e integradores de hardware que desejam embarcar em
          seus computadores um Linux funcional, estável, seguro e totalmente personalizado.<br>
        </h4>
      </v-col>

      <v-col cols="12">
        <div class="info-title">
          <h2 class="mb-3">🌍 Suporte Técnico Profissional</h2>
        </div>
        <h4 class="info-section-black pb-8">
          O Policorp Linux é desenvolvido e mantido por profissionais experientes e certificados. Oferecemos serviços
          Linux de Certificação de Hardware (HCL), OEM, consultoria, migração e suporte corporativo.
        </h4>
      </v-col>
    </v-row>

    <v-row align="center" class="info-section justify-center mb-12">
      <v-col cols="12">
        <div class="info-title">
          <h2 class="mb-3">Por que escolher o Policorp Linux?</h2>
        </div>
        <h4 class="info-section-black pb-12">
          <v-icon color="success">mdi-check-circle</v-icon> Desenvolvimento, manutenção e suporte técnico nacional,
          realizado por profissionais experientes e certificados.<br>
          <v-icon color="success">mdi-check-circle</v-icon> Pronto para usar, o Policorp Linux traz uma seleção de
          aplicativos para atender as necessidades dos usuários, com editor de texto, planilha eletrônica, editor de
          apresentação, editor fotos, navegador de internet, cliente de e-mail e muito mais.<br>
          <v-icon color="success">mdi-check-circle</v-icon> O Policorp Linux em sua versão OEM já está presente em
          vários computadores de grandes fabricantes.<br>
          <v-icon color="success">mdi-check-circle</v-icon> O Kernel (núcleo) do sistema é desenvolvido e mantido
          diretamente pela Policorp, garantindo melhor compatibilidade aos componentes de hardware já certificados.<br>
          <v-icon color="success">mdi-check-circle</v-icon> Versões LTS (Long Term Support) com manutenção e suporte
          para 5 anos ou mais.<br>
          <v-icon color="success">mdi-check-circle</v-icon> Instalação segura com secure boot habilitado por padrão,
          oferecendo mais segurança ao sistema.<br>
          <v-icon color="success">mdi-check-circle</v-icon> Documentação, o Policorp Linux oferece um guia completo do
          usuário além de vários vídeos sobre o uso do sistema. Por ser baseado e compatível com o Debian, Ubuntu e
          derivados, toda documentação e tutoriais desenvolvidos para essas distribuições também podem ser aplicados no
          Policorp.<br>
        </h4>
      </v-col>
    </v-row>

    <v-row align="center" class="info-section justify-center mb-12">
      <v-col cols="12">
        <div class="info-title">
          <h2 class="mb-3">Um ambiente desktop acolhedor <h4>pronto para você!</h4>
          </h2>
        </div>
        <v-img class="pt-12" src="../assets/medium.png"></v-img>
      </v-col>
    </v-row>

    <div class="light-blue-background">
      <v-row align="center" class="info-section justify-center mb-12">
        <v-col cols="12">
          <CardsComponent />
        </v-col>
      </v-row>

      <v-row align="center" class="info-section justify-center">
        <v-col cols="12">
          <div class="info-title">
            <h2 class="mb-3 px-12">Instale seus aplicativos de forma<br> <span>rápida e prática!</span></h2>
          </div>
          <h4 class="text-black pb-12 px-12">Com a nossa poderosa loja de aplicativos, instalar seus programas favoritos
            é fácil e rápido. <br> Com apenas alguns cliques, você pode encontrar, baixar e instalar uma ampla variedade
            de aplicativos, tudo de forma intuitiva e sem complicações. <br> Experimente agora mesmo e tenha acesso a
            milhares de aplicativos em poucos instantes!</h4>
          <div class="apps-image">
            <v-carousel height="655">
              <v-carousel-item class="fixed-app-size" src="../assets/app1.png" draggable="true"></v-carousel-item>
              <v-carousel-item class="fixed-app-size" src="../assets/app2.png" draggable="true"></v-carousel-item>
              <v-carousel-item class="fixed-app-size" src="../assets/app3.png" draggable="true"></v-carousel-item>
            </v-carousel>
          </div>
        </v-col>
      </v-row>

      <v-row align="center" class="d-flex justify-center office-section mt-12">
        <v-col cols="12" md="6" class="d-flex justify-center">
          <div class="left-widget px-12">
            <OfficeIcons />
          </div>
        </v-col>
        <v-col cols="12" md="6" class="icon-text-container">
          <h2 class="text-white text-center">Compatível com todos os seus documentos e arquivos.</h2>
          <h3 class="text-white text-center">
            Seus documentos, músicas, fotos e vídeos funcionam perfeitamente no Policorp Linux. Além disso, o sistema já
            vem pré-instalado com a suíte de escritório LibreOffice, que permite visualizar, criar e editar documentos
            do Microsoft Office/365 de forma totalmente gratuita.
          </h3>
        </v-col>
      </v-row>

    </div>
  </container>
</template>


<script>
import axios from 'axios';
import CardsComponent from './CardsComponent.vue';
import OfficeIcons from './OfficeIcons.vue';



export default {
  components: {
    CardsComponent,
    OfficeIcons,
  },
  data() {
    return {
      showForm: false,
      formData: {
        nome: '',
        email: '',
        ddd: '',
        telefone: '',
      },
      submited: false,
      loading: false,
      downloadLink: 'policorp-13.1-amd64.iso',
    };
  },

  methods: {
    required(v) {
      return !!v || 'Preencha o Campo';
    },
    dddValidationRule(v) {
      return /^\d{2}$/.test(v) || 'DDD deve ter 2 dígitos';
    },
    emailValidationRule(v) {
      return /.+@.+\..+/.test(v) || 'Email inválido';
    },

    submitForm() {
      if (!this.form) return;
      this.submited = true;

      const formDataToSend = {
        nome: this.formData.nome,
        ddd: this.formData.ddd,
        telefone: this.formData.telefone,
        email: this.formData.email,
        mensagem: '', // Inclui o campo mensagem como uma string vazia
      };

      axios.post('https://api.policorp.com.br/api/customers-linux', formDataToSend)
        .then(response => {
          console.log('Form submitted successfully:', response.data);
          const link = document.createElement('a');
          link.href = this.downloadLink; // Define o caminho do arquivo
          link.click();
        })
        .catch(error => {
          console.error('Error submitting form:', error);
          const message = 'Algo deu errado ao fazer a solicitação da imagem. Tente novamente.';
          window.alert(message);
        });
    },

    filter(event) {
      if (!event || !event.charCode) {
        return;
      }

      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    },

    scrollToForm() {
      this.showForm = true; // Exibe o formulário
      this.$nextTick(() => {
        const section = this.$refs.formSection;
        const formElement = this.$refs.form;
        const target = section ? (section.$el || section) : formElement;
        if (target) {
          const elementPosition = target.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - 40,
            behavior: 'smooth'
          });
        }
      });
    }
  }
};
</script>

<style scoped>
@font-face {
  font-family: 'SpaceGrotesk-Bold';
  src: url('~@/assets/fonts/SpaceGrotesk-Bold.ttf') format('woff');
  font-weight: 500;
}

.light-blue-background {
  background-color: #32478D;
  /* Light blue background */
}

.download-section {
  position: relative;
  margin-left: 0;
  margin-right: 0;
  padding-top: 50px;
  padding-bottom: 180px;
  width: 100%;
  background: linear-gradient(180deg, #2c428b 0%, #213063 100%);
  border-bottom-left-radius: 100% 45%;
  border-bottom-right-radius: 100% 45%;
}

.download-section::before {
  content: '';
  position: absolute;
  top: 0;
  /* Change top value */
  left: 0;
  width: 100%;
  height: 100%;
  /* Adjust height as needed */
  background-image: url('~@/assets/wave1.png');
  /* Path to your image asset */
  background-size: cover;
}


.office-section {
  position: relative;
  padding-top: 20px;
  padding-bottom: 100px;
  width: 100%;
  background: linear-gradient(180deg, #2c428b 0%, #213063 100%);
  border-top-left-radius: 100% 45%;
  border-top-right-radius: 100% 45%;
}

.office-section::before {
  content: '';
  position: absolute;
  top: 0;
  /* Change top value */
  left: 0;
  width: 100%;
  height: 100%;
  /* Adjust height as needed */
  background-image: url('~@/assets/wave1.png');
  /* Path to your image asset */
  background-size: cover;
}

.info-section {
  font-family: 'SpaceGrotesk-Bold', sans-serif;
  margin-top: 40px;
  text-align: center;
  color: #959497;
  font-size: 1.2rem;
}

.info-title {
  font-size: 2rem;
  line-height: 60px;
}

.left-widget {
  text-align: center;
  /* Center text horizontally */
  color: white;
  width: 600px;
}

.info-section-black {
  margin-left: 200px;
  margin-right: 80px;
  text-align: justify;
  /* Justifica o texto */
  line-height: 2.3;
  /* Add line height for spacing */
}

.info-section-black h4 {
  text-align: center;
  /* Centraliza o texto dentro da tag <h4> */
}

.right-widget {
  padding-top: 80px;
}

span {
  color: #fefeff;
}

h3 {
  margin: 40px 0 0;
}


ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.text-black {
  color: rgb(255, 255, 255) !important;
  font-size: 1.2rem;
}

a {
  color: #42b983;
}

.apps-image {
  margin-right: 25vw;
  margin-left: 25vw;
}

.icon-text-container {
  max-width: 550px;
  margin-top: 90px;
  padding-left: 40px;
  padding-right: 40px;
}

.v-icon.mdi-check-circle {
  color: #4caf50;

}

.text-black {
  color: #000;

}

.alert-link {
  color: #0000EE !important;
  text-decoration: underline !important;
  font-weight: bold;
}

.install-warning {
  border-left: 6px solid #64b5f6 !important;
  background-color: rgba(25, 118, 210, 0.08);
  color: #0d47a1 !important;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-align: center;
  line-height: 1.6;
}

@media (max-width: 1164px) {
  .apps-image {
    margin-left: 20px;
    margin-right: 20px;
  }

  .info-section-black {
    margin-left: 60px;
    margin-right: 60px;
  }

  .left-widget {
    width: auto;
  }
}

@media (max-width: 960px) {
  .info-section {
    font-size: 1rem;
    padding: 0 24px;
  }

  .info-title {
    line-height: 1.4;
  }

  .info-section-black {
    margin-left: 20px;
    margin-right: 20px;
  }

  .apps-image {
    margin-left: 12px;
    margin-right: 12px;
  }

  .icon-text-container {
    margin-top: 45px;
    padding-left: 24px;
    padding-right: 24px;
  }
}

@media (max-width: 768px) {


  .left-widget {
    width: 100%;
    padding: 0 12px;
  }

  .right-widget {
    padding-top: 30px;
  }

  .info-section-black {
    margin-left: 0;
    margin-right: 0;
  }

  .text-black {
    font-size: 1rem;
  }

  .apps-image {
    margin-left: 0;
    margin-right: 0;
  }

  .icon-text-container {
    padding-left: 12px;
    padding-right: 12px;
  }

  h3 {
    margin: 24px 0 0;
  }
}

@media (max-width: 600px) {
  .download-section {
    padding-top: 30px;
    padding-bottom: 100px;
  }

  .office-section {
    padding-top: 30px;
    padding-bottom: 70px;
  }

  .info-title {
    font-size: 1.6rem;
  }

  .info-section {
    padding: 0 12px;
  }

  .text-black {
    font-size: 0.95rem;
  }

  .apps-image {
    margin-left: 0;
    margin-right: 0;
  }

  .icon-text-container {
    margin-top: 24px;
  }
}
</style>
